import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useOrganizationStore } from './state/OrganizationContainer';

// todo: better error management
export function useManagedOrgsFetching() {
    const { organizationId } = useParams<{ organizationId: string }>();
    const orgManagedOrgs = useOrganizationStore((state) => state.orgManagedOrgs);
    const isLoading = useOrganizationStore((state) => state.loadingData.managedOrgs);

    useEffect(() => {
        async function initializeManagedOrgs() {
            if (!organizationId || useOrganizationStore.getState().loadingData.managedOrgs == true) return;
            useOrganizationStore.getState().handleLoadingDataChange('managedOrgs', true);

            const org = useOrganizationStore
                .getState()
                .orgManagedOrgs.find((mo) => mo.originatedByOrganizationId == organizationId);

            if (org) {
                useOrganizationStore.getState().handleLoadingDataChange('managedOrgs', false);
                return;
            }

            try {
                const result = await useOrganizationStore.getState().getOrgManagedOrgsAll(organizationId);
                if (result?.resultType !== 'Ok') {
                    // Handle error case, e.g., show an alert
                }
            } catch (error) {
                console.error('Error loading managed organizations.');
            } finally {
                useOrganizationStore.getState().handleLoadingDataChange('managedOrgs', false);
            }
        }

        initializeManagedOrgs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    return { orgManagedOrgs, isLoading };
}
